import styled, { css } from 'styled-components';
import { PaddingX } from './styled';
import { MenuItem as MenuItemType } from './types';
import { Collapse as CollapseAtom } from '../../atoms/collapse';
import { SearchInputExpanded } from '../../atoms/input/search-input-expanded';
import { MenuList } from '../../atoms/menu/menu-list';
import { Page } from '../../molecules/page';
import { Heading03, HeadingCompact00 } from '../../styles';

export const PageHeader = styled.div`
  ${PaddingX};
  ${Heading03};
  &.heading-box-shadow {
    box-shadow: var(--shadow-krypton-bottom);
    z-index: 1;
  }
  ${SearchInputExpanded} {
    margin: var(--spacing-05) 0;
  }
`;

export const LeftMenuContentWrapper = styled.div`
  overflow: auto;
  ${PaddingX};
  padding-bottom: var(--spacing-09);
  flex-grow: 1;
  ${MenuList} > li > a {
    padding: var(--spacing-03);
  }
`;

export const LeftMenu = styled(Page.LeftMenu)`
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
`;

const MenuSpanWrapper = styled.span`
  display: flex;
  align-items: center;
`;

const MenuSpan = styled(MenuSpanWrapper)`
  gap: var(--spacing-03);
  > svg {
    color: var(--gray-70);
  }
`;

const Intendation = styled.div<{ level: number }>`
  width: ${(props) => `${props.level * 8}px`};
`;

const MenuItemWrapper = styled.div`
  display: flex;
  align-items: center;
  > :first-child {
    flex-grow: 1;
  }
`;

export const MenuHeader = styled.p`
  ${HeadingCompact00};
  margin-bottom: 0;
`;

export const CollapsibleMenuGroup = styled(CollapseAtom)<{
  $level: number;
  $hideBorder?: boolean;
}>`
  border-radius: 0;
  .ant-collapse-item .ant-collapse-header {
    height: 32px;
    background-color: transparent;
    padding: 0 var(--spacing-03);
    border-radius: var(--border-radius-small);
    border: none;
  }
  .ant-collapse-item .ant-collapse-header > svg {
    top: 10px;
  }
  .ant-collapse-item,
  .ant-collapse-content {
    background-color: transparent;
  }

  .ant-collapse-item.ant-collapse-item-active {
    padding-bottom: 0;
  }

  &.ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header
    .ant-collapse-arrow {
    padding-top: 0;
    display: flex;
    align-items: center;
    height: 100%;
    right: 1rem;
  }
  ${({ $level, $hideBorder }) => {
    if ($level === 0 && !$hideBorder) {
      return css`
        margin-bottom: var(--spacing-05);
        padding-bottom: var(--spacing-05);
        border-bottom: 1px solid var(--divider-default);
      `;
    }
  }};
`;

export const MenuItem = ({
  item,
  level,
}: {
  item: MenuItemType;
  level: number;
}) => {
  return (
    <MenuItemWrapper>
      <MenuSpanWrapper>
        <Intendation level={level} />
        <MenuSpan>
          {item.menuIcon}
          {item.menuName}
        </MenuSpan>
      </MenuSpanWrapper>
    </MenuItemWrapper>
  );
};
